import React from "react";
import Table from "../../Common/Table";
import { getPath, getReadableDateTime } from "../../../utils";

const DriverServicesChangeLogList = ({ changes, tableFields }) => {
  const getFieldValue = (change, key) => {
    switch (key) {
      case "timestamp":
        return getReadableDateTime(change[key]);
      default:
        return change[key] !== undefined ? change[key] + "" : "N/A";
    }
  };

  return (
    getPath(changes, "length", undefined) > 0 && (
      <React.Fragment>
        <h3 className="ml-10">Change Logs</h3>
        <Table
          dataTestid="changelogList"
          list={changes}
          getFieldValue={getFieldValue}
          fields={tableFields}
        />
      </React.Fragment>
    )
  );
};

export default DriverServicesChangeLogList;
